<!--<div [ngSwitch]="(currentLanguage$ | async).id">
  <colimo-privacy-policy-de *ngSwitchCase="'de'"></colimo-privacy-policy-de>
  <colimo-privacy-policy-en *ngSwitchDefault></colimo-privacy-policy-en>
</div>-->
<!-- currently only english private policy-->
<div>
  <colimo-privacy-policy-en></colimo-privacy-policy-en>
</div>
